const endpoints = {
  audit: {
    endpoint: "audit",
  },
  auth: {
    login: "auth/login",
    login2fa: "auth/2fa",
    logout: "auth/logout",
    me: "auth/me",
    mePassChange: "auth/change-password",
  },
  bank: {
    endpoint: "bank-detail",
  },
  company: {
    endpoint: "company",
    endpoints: "companies",
  },
  country: {
    endpoint: "country",
    endpoints: "countries",
  },
  device: {
    endpoint: "device",
  },
  entity_log: {
    endpoint: "entity-change-log",
  },
  firewall: {
    endpoint: "loto-firewall",
  },
  genreports_api_imports: {
    endpoint: "reports-manager/api-financial",
    reimport: "reports-manager/reimport"
  },
  genreports_cash_register: {
    endpoint: "report/aggregates/cash-register",
  },
  genreports_cash_required: {
    endpoint: "shop-cash-required",
  },
  genreports_daily_monthly_income: {
    endpoint: "report/aggregates/daily-monthly-income"
  },
  genreports_device_income_payment: {
    endpoint: "report/aggregates/device-income-payments"
  },
  genreports_income_payment: {
    endpoint: "report/aggregates/income-payments",
  },
  genreports_manual_report: {
    endpoint: "reports-manager/add-manual-financial-report"
  },
  genreports_receipts_winnings: {
    endpoint: "report/aggregates/income-winnings",
  },
  genreports_shop_balance: {
    endpoint: "shop-balances",
  },
  genreports_shop_balance_tx: {
    endpoint: "shop-balance-tx",
    endpoints: "shop-balance-txs",
    deleteEndpoint: "shop-balance-tx"
  },
  genreports_online_payouts: {
    endpoint: "online-payouts",
  },
  image_upload: {
    endpoint: "reports-manager/counters-image-upload",
  },
  liability_counter: {
    endpoint: "liability-counter",
  },
  lottery_event: {
    endpoint: "loto-event",
  },
  lottery_system: {
    endpoint: "loto-system",
  },
  lottery_ticket_authorization: {
    endpoint: "loto-ticket-authorization",
  },
  online_cash_tx: {
    endpoint: "online-cash-tx",
    endpoints: "online-cash-txs",
    endpointCancel: "online-cash-tx-cancel",

    identifyEndpoint: "oco-identify",
    depositEndpoint: "oco-deposit"
  },
  online_player: {
    endpoint: "online-player",
  },
  operator: {
    endpoint: "cash-operator",
  },
  permissions: {
    endpoint: "permission",
  },
  player: {
    endpoint: "player",
  },
  product: {
    endpoint: "product",
    endpoints: "products",
  },
  registry: {
    endpoint: "registry",
    endpoints: "registries",
  },
  reports_cash_result: {
    endpoint: "report/cash-result",
  },
  reports_expired_winning: {
    endpoint: "report/expired-winning",
  },
  reports_lottery_offer: {
    endpoint: "report/events-offer",
  },
  reports_lottery_result: {
    endpoint: "report/events-results",
  },
  reports_lottery_system_performance: {
    endpoint: "report/systems-performance",
  },
  reports_return_player: {
    endpoint: "report/cash-player",
  },
  reports_taxed_paid_ticket: {
    endpoint: "report/paid-ticket",
  },
  role: {
    endpoint: "role",
  },
  shop: {
    endpoint: "shop",
    endpointShopLimit: "loto-limits",
  },
  shop_cash_tx: {
    endpoint: "shop-cash-tx",
    endpoints: "shop-cash-txs",
    endpointCancel: "shop-cash-tx-cancel"
  },
  shop_epos_tx: {
    endpoint: "epos-tx",
    endpoints: "epos-txs",
    endpointCancel: "epos-tx-cancel"
  },
  shop_group: {
    endpoint: "shop-group",
  },
  slot: {
    endpoint: "slot",
    uploadedImage: "reports-manager/counters-image-get",
  },
  slot_report: {
    endpoint: "slot-report",
    uploadEndpoint: "reports-manager/counters-image-create",
  },
  subtype: {
    endpoint: "cash-subtype",
  },
  tenant: {
    endpoint: "tenant",
  },
  terminal: {
    endpoint: "terminal",
  },
  terminal_activity: {
    endpoint: "report/terminal-activity",
    endpointDetails: "report/terminal-activity-details"
  },
  third_party_player: {
    endpoint: "third-party-player",
  },
  ticket: {
    endpoint: "loto-ticket",
    endpointReserved: "loto-ticket-reservation",
  },
  token: {
    endpoint: "token",
  },
  user: {
    endpoint: "user",
  },
  user_activity: {
    endpoint: "notifications/user-activity",
  },
  user_clocking: {
    endpoint: "report/user-monthly-activity",
  },
  user_activity_manual: {
    endpoint: "report/user-activity-manual",
    endpoints: "report/users-activity-manual",
  },
  user_clocking_manual: {
    endpoint: "report/user-monthly-activity-manual",
  },
  ws: {
    wsPath: "ws",
  },
  operators_report: {
    endpoint: "report/operator-income"
  },
  jackpot: {
    endpoint: "jackpot",
    endpoints: "jackpots",
    reset: "jackpot-reset"
  },
  jackpot_history: {
    endpoint: "jackpot-wins",
  },
  raffle: {
    endpoint: "raffle/clients",
    endpoint_serials: "raffle/serials",
  },
  shop_visits: {
    endpoint: "shop-visits",
  }
};

export default endpoints;
